import { createAction } from '@reduxjs/toolkit';

// entrypoint actions
export const GET_ALL_META_DATA = 'GET_ALL_META_DATA';

export const CLEAR_SETTINGS_STORE = 'CLEAR_SETTINGS_STORE';

export const GETTING_ALL_META_DATA = 'GETTING_ALL_META_DATA';

export const GETTING_ALL_META_DATA_SUCCEEDED = 'GETTING_ALL_META_DATA_SUCCEEDED';

export const GETTING_ALL_META_DATA_FAILED = 'GETTING_ALL_META_DATA_FAILED';

export const SAVE_SETTINGS_SUCCEEDED = 'SAVE_SETTINGS_SUCCEEDED';

export const UPDATE_SETTINGS_META_DATA = 'UPDATE_SETTINGS_META_DATA';

export const UPDATING_SETTINGS_META_DATA = 'UPDATING_SETTINGS_META_DATA';

export const UPDATING_SETTINGS_META_DATA_SUCCEEDED = 'UPDATING_SETTINGS_META_DATA_SUCCEEDED';

export const UPDATING_SETTINGS_META_DATA_FAILED = 'UPDATING_SETTINGS_META_DATA_FAILED';

export const SET_TIME_ZONE_MODIFIED = 'SET_TIME_ZONE_MODIFIED';

export const UNSET_TIME_ZONE_MODIFIED = 'UNSET_TIME_ZONE_MODIFIED';

export const GET_AVAILABLE_LANGUAGES = 'GET_AVAILABLE_LANGUAGES';

export const GET_AVAILABLE_LANGUAGES_SUCCEEDED = 'GET_AVAILABLE_LANGUAGES_SUCCEEDED';

export const GET_AVAILABLE_LANGUAGES_FAILED = 'GET_AVAILABLE_LANGUAGES_FAILED';

export const UPDATE_LANGUAGE_PREFERENCE = 'UPDATE_LANGUAGE_PREFERENCE';

export const UPDATE_TEMPLATE_LANGUAGE_PREFERENCE = 'UPDATE_TEMPLATE_LANGUAGE_PREFERENCE';

export const getAllMetaData = createAction(GET_ALL_META_DATA);

export const clearSettingsStore = createAction(CLEAR_SETTINGS_STORE);

export const gettingAllMetaData = createAction(GETTING_ALL_META_DATA);

export const gettingAllMetaDataSucceeded = createAction(
  GETTING_ALL_META_DATA_SUCCEEDED
);
export const gettingAllMetaDataFailed = createAction(
  GETTING_ALL_META_DATA_FAILED
);

export const saveSettingsSucceeded = createAction(SAVE_SETTINGS_SUCCEEDED);

export const updateSettingsMetaData = createAction(UPDATE_SETTINGS_META_DATA);

export const updatingSettingsMetaData = createAction(UPDATING_SETTINGS_META_DATA);

export const updatingSettingsMetaDataSucceeded = createAction(UPDATING_SETTINGS_META_DATA_SUCCEEDED);

export const updatingSettingsMetaDataFailed = createAction(UPDATING_SETTINGS_META_DATA_FAILED);

export const setTimeZoneModified = createAction(SET_TIME_ZONE_MODIFIED);

export const unsetTimeZoneModified = createAction(UNSET_TIME_ZONE_MODIFIED);

export const getAvailableLanguages = createAction(GET_AVAILABLE_LANGUAGES);

export const getAvailableLanguagesSucceeded = createAction(GET_AVAILABLE_LANGUAGES_SUCCEEDED);

export const getAvailableLanguagesFailed = createAction(GET_AVAILABLE_LANGUAGES_FAILED);

export const updateLanguagePreference = createAction(UPDATE_LANGUAGE_PREFERENCE);

export const updateTemplateLanguagePreference = createAction(UPDATE_TEMPLATE_LANGUAGE_PREFERENCE);